(function($){
    (!window.Runway) && (window.Runway = {});

    $(document).ready(() => {
        // логика инициализации 
    });
// eslint-disable-next-line no-undef
})(jQuery)